module.exports = __webpack_public_path__ + "img/3.ca12536f.png";